import React from 'react';
var Mapper = function Mapper(_ref) {
  var items = _ref.items,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, index) {
    return children(item, index);
  }));
};
export { Mapper };